var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShieldCheck = function SvgIconShieldCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.815 10.474a1 1 0 0 0-1.38-1.448l-4.812 4.591-2.057-1.965a1 1 0 0 0-1.382 1.446l2.747 2.625a1 1 0 0 0 1.381 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 3.5a1.75 1.75 0 0 0-1.75 1.75v5.503c0 8.562 7.27 11.395 8.688 11.867.364.13.76.13 1.124 0 1.418-.472 8.688-3.305 8.688-11.867V5.25A1.75 1.75 0 0 0 19.5 3.5zm.25 7.253V5.5h14.5v5.253c0 7.022-5.82 9.455-7.25 9.946-1.43-.49-7.25-2.924-7.25-9.946",
    clipRule: "evenodd"
  }))));
};
export default SvgIconShieldCheck;